/** Fixed perk categories for products and season passes */
export const ENTITLEMENT_OPTIONS = [
  'Admission',
  'Parking',
  'Retail',
  'Food',
  'Rides',
];

export const EMPTY_PERK = {
  title: '',
  category: 'Admission',
  description: '',
};

function resolvePerkCategory(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return (
    ENTITLEMENT_OPTIONS.find((option) => option.toLowerCase() === raw.toLowerCase()) || ''
  );
}

export function normalizePerk(entry) {
  if (entry == null) return null;
  if (typeof entry === 'string') {
    const title = entry.trim();
    if (!title) return null;
    const category = resolvePerkCategory(title);
    return { title, category, description: '' };
  }
  if (typeof entry !== 'object' || Array.isArray(entry)) return null;
  const category = resolvePerkCategory(entry.category);
  const title = String(entry.title || '').trim() || category;
  const description = String(entry.description || '').trim();
  if (!title && !category && !description) return null;
  return {
    title: title || category || 'Perk',
    category,
    description,
  };
}

export function parseEntitlements(list) {
  if (!Array.isArray(list)) return [];
  return list.map(normalizePerk).filter(Boolean);
}

export function formatPerkLabel(perk) {
  const normalized = normalizePerk(perk);
  if (!normalized) return '';
  if (normalized.category && normalized.title && normalized.category !== normalized.title) {
    return `${normalized.category}: ${normalized.title}`;
  }
  return normalized.title || normalized.category || '';
}
